import ReportView from './Report'

export default ReportView
